import {
  OasError,
  OasErrorConstructor,
  getOasErrorFromError,
  OasErrorOptions,
  OasErrorInterface,
} from './oas-error';

export const OasMemoryError: OasErrorConstructor = class OasMemoryError extends OasError {
  static fromError(e: unknown, options?: OasErrorOptions): OasErrorInterface {
    return getOasErrorFromError(OasMemoryError, e, options);
  }

  constructor(message?: string, options?: OasErrorOptions) {
    super(message, { ...options, type: 'OasMemoryError' });
  }
};
